import React from "react";
import styled from "styled-components";

import UIInput from "components/UI/Input";
import UILabel from "components/UI/Label";
import UIButtonPrimary from "components/UI/Button/Primary";
import UIPrimaryWidgetBox from "components/UI/PrimaryWidgetBox";
import commonStyles from "css/common.module.css";

const Container = styled.div.attrs({ className: "change-password" })`
  & .row {
    margin: 0 0 24px;
    width: 100%;
    text-align: center;
  }
  & .control {
    display: inline-block;
    margin: 0 24px 0 0;
    width: calc(25% - 24px);
    text-align: left;
  }
  & .change-password-btn {
    height: 36px;
    font-weight: bold;
    padding: 6px 34px;
  }
  .title {
    font-size: 19px;
    font-weight: bold;
    margin: 0 0 24px;
  }
  & .required-field {
    font-size: 12px;
    vertical-align: text-top;
    margin-left: 2px;
    color: #194fa1;
  }
`;

class ChangePasswordView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        uid: "",
        pwd: "",
        newpwd: "",
        confirmpwd: "",
        vs: ""
      },
      classes :{
        uid: "",
        pwd: "",
        newpwd: "",
        confirmpwd: "",
        vs: ""
      }
    };
  }
  onChange(e) {
    var input = e.target.name;
    var value = e.target.value;
    this.setState(prevState => ({
      values :{
        ...prevState.values,
        [input]: value
      }
    }));
}

  onSubmit(e) {
    e.preventDefault();
    var inputFields = this.state.values;
    for (var key in inputFields){
      this.state.classes[key] = inputFields[key] === "" ? "error" : "";;
    }
    this.props.changePassword(this.state.values);
  }

  render (){
    return (
      <Container
        style={{backgroundColor:'#EDEDED'}}
        className={`${commonStyles.page} ${commonStyles.padded} ${commonStyles.clear }`}
      >
        <UIPrimaryWidgetBox className="p" style={{height:'100%'}}>
          <form id="changePassword" onSubmit={this.onSubmit.bind(this)}>
            <div className="title">Change Password</div>
            <div className="row">
              <div className="control">
                <UILabel>User ID</UILabel><span className="required-field">*</span>
                <UIInput type="Text" name="uid" className={this.state.classes.uid} autoComplete="off" onChange={this.onChange.bind(this)} />
              </div>
            </div>
            <div className="row">
              <div className="control">
                <UILabel>Old Password</UILabel><span className="required-field">*</span>
                <UIInput type="Password" name="pwd" className={this.state.classes.pwd} onChange={this.onChange.bind(this)} />
              </div>
            </div>
            <div className="row">
              <div className="control">
                <UILabel>New Password</UILabel><span className="required-field">*</span>
                <UIInput type="Password" name="newpwd" className={this.state.classes.newpwd} onChange={this.onChange.bind(this)} />
              </div>
            </div>
            <div className="row">
              <div className="control">
                <UILabel>Confirm New Password</UILabel><span className="required-field">*</span>
                <UIInput type="Password" name="confirmpwd" className={this.state.classes.confirmpwd} onChange={this.onChange.bind(this)} />
              </div>
            </div>
            <div className="row">
              <UIButtonPrimary
                className="change-password-btn"
                type="submit">
                Change Password
              </UIButtonPrimary>
            </div>
          </form>
        </UIPrimaryWidgetBox>
      </Container>
    );
  }
}

export default ChangePasswordView;
